import { RadioButton } from '../../controls'
import { Field } from '../field'
import type { RadioButtonFieldProps } from './types'

const RadioButtonField = ({
  label,
  disabled,
  error,
  align,
  onChange,
  ...rest
}: RadioButtonFieldProps) => {
  return (
    <Field error={error} {...rest}>
      <RadioButton
        {...rest}
        disabled={disabled}
        error={!!error}
        label={label}
        align={align}
        onChange={onChange}
      />
    </Field>
  )
}
export default RadioButtonField
